export default {
  SET_TELEMETRY_ENTRIES(state, telemetryEntries) {
    state.telemetryEntries = telemetryEntries;
  },

  SET_LOADING(state, loading) {
    state.loading = loading;
  },

  SET_PAGE(state, page) {
    state.page = page;
  },

  SET_SORT_BY(state, sortBy) {
    state.sortBy = sortBy;
  },

  SET_ORDER_BY(state, orderBy) {
    state.orderBy = orderBy;
  },

  SET_SEARCH(state, search) {
    state.search = search;
  },
};
